import { t } from "i18next";
import styled from "styled-components";
import Typography from "../typography/Typography";

interface IInput {
  placeholder?: string;
  style?: React.CSSProperties;
  onChange?: any;
  value: string;
  maxLength?: number;
  onPressEnter?: any;
  autoFocus?: boolean;
  maxLenght?: number;
}

const Container = styled.input`
  border: none;
  outline: none;
  padding-bottom: 8px;
  width: 100%;
  background-color: transparent;

  /* ParagraphS */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 114.286% */
  letter-spacing: 0.2px;

  border-bottom: 1px solid ${(props) => props.theme.colors.line};

  transition: all 0.5s;

  &:focus {
    color: ${props => props.theme.colors.body};
    border-bottom: 1px solid ${(props) => props.theme.colors.body};

    &:hover {
      border-bottom: 1px solid ${(props) => props.theme.colors.body};

      &::placeholder {
        color: ${(props) => props.theme.colors.body};
      }
    }
  }

  &:hover {
    border-bottom: 1px solid ${(props) => props.theme.colors.placeholder};
  }

  input::placeholder {
    color: ${(props) => props.theme.colors.placeholder};
  }
`;

const Input: React.FC<IInput> = ({
  placeholder,
  style,
  onChange,
  value,
  maxLength,
  onPressEnter,
  autoFocus,
}) => {
  const handleEnter = (e: any) => {
    if (e.key === "Enter" && onPressEnter !== undefined) {
      onPressEnter();
    }
  };

  return (
    <>
      <Container
        className="dashboard-input"
        placeholder={placeholder}
        style={style}
        onChange={onChange}
        value={value}
        maxLength={maxLength}
        onKeyPress={handleEnter}
        autoFocus={autoFocus ? autoFocus : false}
      />
      {maxLength && (
        <Typography 
          type="paragraphXXS" 
          color="label"
          style={{marginLeft: 'auto'}}
          >
         {`${t('chars') + " "} ${value.trim().length} ${maxLength ? `/ ${maxLength}` : ""}`}
          </Typography>
      )}
    </>
  );
};

export default Input;
